interface SleepingLine {
  text: string;
  note?: string;
  suffix?: string;
}

interface VillaConfiguration {
  name: string;
  sleeping: SleepingLine[];
  guests: string;
  emphasizeDesktopName?: boolean;
}

export const villaConfigurations: VillaConfiguration[] = [
  {
    name: "Toka 1 bed villa (Awa)",
    sleeping: [{ text: "1 Super King Bed", note: "(can split into 2 single beds)" }],
    guests: "2",
  },
  {
    name: "Toka 2 bed villa (Ngahere)",
    sleeping: [{ text: "2 Queen Beds" }],
    guests: "4",
  },
  {
    name: "Toka 3 bed villa (Ngawha)",
    sleeping: [
      { text: "2 Super King Beds", note: "(2 can split into single beds)", suffix: "," },
      { text: "1 King Bed" },
    ],
    guests: "6",
  },
  {
    name: "Toka 4 bed villa (Kōkō)",
    sleeping: [
      { text: "2 Super King Beds", note: "(2 can split into single beds)", suffix: "," },
      { text: "2 King Beds" },
    ],
    guests: "8",
  },
  {
    name: "Extra: Roll Away Beds",
    emphasizeDesktopName: true,
    sleeping: [
      { text: "$89 per villa - 2 single beds" },
      { text: "", note: "(Only 1 available per villa)" },
    ],
    guests: "2",
  },
  {
    name: "All Toka Ridge villas",
    sleeping: [
      { text: "5 Super King Beds", note: "(5 can split into single beds)", suffix: "," },
      { text: "3 King Beds, 2 Queen Beds, 2 Roll Away Single Beds" },
    ],
    guests: "22",
  },
  {
    name: "Above Par 4 bed villa",
    sleeping: [
      { text: "2 Super King Beds", note: "(2 can split into singles)", suffix: "," },
      { text: "2 Queen Beds" },
    ],
    guests: "8",
  },
];